import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Panel } from "../components/Surface";
import { Button } from "../components/ui/Button";
import { StatusLabel } from "../components/ListTable";
import { myAuctions, auctionPrice, timeLeft, type Auction } from "../lib/auctions";

export function MyAuctions() {
  const [auctions, setAuctions] = useState<Auction[]>([]);

  useEffect(() => { myAuctions().then((r) => setAuctions(r.auctions)).catch(() => undefined); }, []);

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader title="My auctions" subtitle="Auctions you're selling or bidding on." actions={<Link to="/auctions"><Button variant="ghost">Auctions</Button></Link>} />
      {auctions.length === 0 ? (
        <p className="text-sm text-muted">Nothing yet. <Link to="/auctions" className="font-bold text-accent-strong">Browse auctions →</Link></p>
      ) : (
        <div className="grid gap-2">
          {auctions.map((a) => (
            <Panel key={a.id}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="min-w-0">
                  <Link to={`/auctions/${a.id}`} className="font-bold hover:text-accent-strong">{a.title}</Link>
                  <p className="font-mono text-[11px] text-muted">{a.selling ? "Selling" : "Bidding"} · {auctionPrice(a.current_price_cents)} · {a.status === "active" ? timeLeft(a.ends_at) : "ended"}</p>
                </div>
                <StatusLabel status={a.status ?? "active"} />
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
